import { render } from "./ServiceDetailMaintenance.vue?vue&type=template&id=70987976"
import script from "./ServiceDetailMaintenance.vue?vue&type=script&lang=js"
export * from "./ServiceDetailMaintenance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__